// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./source/sass/main.scss
// module id = 18
// module chunks = 1